/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Einvoice_Draft_Source_ChangedInputs */

const vi_einvoice_draft_source_changed = /** @type {(inputs: Einvoice_Draft_Source_ChangedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đơn hàng đã thay đổi từ khi lưu bản nháp. Nội dung bạn đã chỉnh vẫn được giữ. Để lấy dữ liệu đơn hàng mới, hãy xác nhận tạo lại nháp.`)
};

/**

* @param {Einvoice_Draft_Source_ChangedInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const einvoice_draft_source_changed = /** @type {((inputs?: Einvoice_Draft_Source_ChangedInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Einvoice_Draft_Source_ChangedInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_einvoice_draft_source_changed(inputs)
});